import { BranchService, BranchStateService, ProjectService } from '@alpha-core/platform-ui';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { BranchNotFoundDialogComponent } from '../components/shared/dialog/branch-not-found-dialog.component';

export const branchValidationGuard: CanActivateFn = async (route) => {
    const branchService = inject(BranchService);
    const branchStateService = inject(BranchStateService);
    const projectService = inject(ProjectService);
    const dialogService = inject(DialogService);

    // Get projectId from query params first (available on initial load),
    // fall back to stored project for subsequent navigations
    const projectId = route.queryParams['projectId'] || projectService.fetchCurrentProject()?.projectId;
    const branch = route.queryParams['branch'] || 'main';

    // Skip validation for 'main' branch or if no projectId
    if (branch === 'main' || !projectId?.trim()) {
        return true;
    }

    try {
        const branchExists = await firstValueFrom(branchService.validateBranch(projectId, branch));

        if (!branchExists) {
            // Set branch state to main
            branchStateService.setBranch('main');

            // Show dialog - clicking OK will do browser refresh with main branch
            dialogService.open(BranchNotFoundDialogComponent, {
                header: `Branch "${branch}" not found. Redirecting to main branch.`,
                width: '35rem',
                closable: false,
            });

            // Return false to block navigation - dialog's OK button will do browser refresh
            return false;
        }
    } catch (error) {
        console.error('Error validating branch:', error);
        // On error, show dialog and redirect to main branch
        branchStateService.setBranch('main');

        dialogService.open(BranchNotFoundDialogComponent, {
            header: `Branch "${branch}" not found. Redirecting to main branch.`,
            width: '35rem',
            closable: false,
        });

        return false;
    }

    return true;
};
